var $3d5058299051dde5$exports = {};
$3d5058299051dde5$exports = {
  "pending": `\u{642}\u{64A}\u{62F} \u{627}\u{644}\u{627}\u{646}\u{62A}\u{638}\u{627}\u{631}`
};
export { $3d5058299051dde5$exports as default };